import AdmcsmUtilService from "./AdmcsmUtilService";

const admcsmUtilService = new AdmcsmUtilService();

export default {
  searchMenu(params) {
    let api = `/api/v2/menu/search`;
    params.page = params.page - 1;
    return admcsmUtilService.get(api, { params });
  },
  getAllMenu() {
    let api = `/api/v2/menu/all`;
    return admcsmUtilService.get(api);
  },
  getUserMenu() {
    let api = `/api/v2/menu/menu-parent-child-for-router`;
    return admcsmUtilService.get(api);
  },
  getStrictedRoute() {
    let api = `/api/v2/menu/menu-flat`;
    return admcsmUtilService.get(api);
  },
  addMenu(data) {
    let api = `/api/v2/menu`;
    return admcsmUtilService.post(api, data);
  },
  editMenu(data) {
    let api = `/api/v2/menu`;
    return admcsmUtilService.put(api, data);
  },
  deleteMenu(params) {
    let api = `/api/v2/menu`;
    return admcsmUtilService.delete(api, { params });
  },
  getAllStation() {
    let api = `/station`;
    return admcsmUtilService.get(api);
  },
  getUserStation() {
    let api = `/user/station`;
    return admcsmUtilService.get(api);
  },

  // Nhóm
  searchGroup(params) {
    let api = `/group/search`;
    params.page = params.page - 1;
    return admcsmUtilService.get(api, { params });
  },
  addGroup(data) {
    let api = `/group`;
    return admcsmUtilService.post(api, data);
  },
  editGroup(data) {
    let api = `/group`;
    return admcsmUtilService.put(api, data);
  },
  deleteGroup(params) {
    let api = `/group`;
    return admcsmUtilService.delete(api, { params });
  },
  getUserInGroup(params, cancelToken) {
    let api = `/group/user-in-group`;
    return admcsmUtilService.get(api, { params, cancelToken });
  },
  editGroupUserPermission(data) {
    let api = `/group/add-remove`;
    return admcsmUtilService.post(api, data);
  },

  // Permission
  getMenuByGroup(params) {
    let api = `/permission/menu-by-group`;
    return admcsmUtilService.get(api, { params });
  },
  getUserByGroup(params) {
    let api = `/permission/menu-by-user`;
    return admcsmUtilService.get(api, { params });
  },

  editGroupPermission(data) {
    let api = `/permission`;
    return admcsmUtilService.post(api, data);
  },

  // User
  addUser(data) {
    let api = `/user`;
    return admcsmUtilService.post(api, data);
  },
  editUser(data) {
    let api = `/user`;
    return admcsmUtilService.put(api, data);
  },
  searchUser(params) {
    let api = `/user/find`;
    return admcsmUtilService.get(api, { params });
  },
  getUser(params) {
    let api = `/user/search`;
    params.page = params.page - 1;
    return admcsmUtilService.get(api, { params });
  },
  deleteUser(params) {
    let api = `/user`;
    return admcsmUtilService.delete(api, { params });
  }
};
